module.exports = "<div class=\"wrapper\">\r\n  <app-header></app-header>\r\n  <app-redes-sociales></app-redes-sociales>\r\n  <router-outlet></router-outlet>\r\n  <div class=\"container bg-container\"></div>\r\n  <app-otro-interes></app-otro-interes>\r\n  <app-footer></app-footer>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main